module.exports = "pegasus_template/assets/blocks/pop-up-layout-buttons.png";